module.exports = __webpack_public_path__ + "static/media/cat8.eedda188.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat8.jpeg
// module id = 40
// module chunks = 0